<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('societes.mentionsLegales.title')}}
      </p>
    </header>
    <div class="card-content">
      <div class="column is-12">
        <b-field custom-class="has-text-weight-normal is-italic is-marginless"
                 :label='$t("societes.mentionsLegales.retardPaiement")'>
          <div v-html="societe.retardPaiement"></div>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    societe: Object,
  },
};
</script>
